import Vuex from 'vuex';

export default {
    use: function (Vue) {
        Vue.use(Vuex);
        let store = new Vuex.Store({
            state: {
                account: {},
                alert: { show: false },
                dark: false,
                dialog: { show: false },
                tenant: {},
                loading: { show: false, msg: '正在处理~' },
                notifications: [],
                notificationCount: { total: 0, unRead: 0 },
                rightDrawer: null,
            },
            mutations: {
                account(state, a) {
                    state.account = a;
                },
                alert(state, o) {
                    state.loading.show = false;
                    state.alert = o;
                },
                dark(state, d) {
                    state.dark = d;
                },
                dialog(state, d) {
                    state.dialog = d;
                },
                tenant(state, t) {
                    state.tenant = t;
                },
                loading(state, l) {
                    state.loading = l;
                },
                notify(state, n) {
                    state.notifications.unshift(n);
                },
                notificationCount(state, c) {
                    state.notificationCount = c;
                },
                rightDrawer(state, n){
                    state.rightDrawer = n;
                }
            }
        });
        return store;
    }
};